import React, { memo } from "react"
import { Badge, Flex, Select, Space } from "antd"
import PropTypes from "prop-types"
import { useMediaQuery } from "react-responsive"
import { FilterIcon } from "ui/Icon/DSIcon/Filter"
import { usePagination } from "../hooks/usePagination"
import TabPill from "./TabPill"
import ViewToggle from "./ViewToggle"
import styles from "../index.module.css"

const FilterButtons = memo(
  ({
    selectedListing,
    setSelectedListing,
    t,
    activeTab,
    onTabChange,
    activeListingTab,
    onListingTabChange,
    publishedCount,
    draftCount,
    unpublishedCount,
    isFilterDropdownOpen,
    onFilterIconClick,
    onCloseFilterDropdown,
    FilterDropdown,
    onApplyFilters,
    onClearFilters,
    selectedCategoryIds,
    selectedDurationTypes,
    activeFilterCount
  }) => {
    const isCompactDevice = useMediaQuery({ query: "(max-width: 1280px)" })
    const { setPage } = usePagination(1, 10)

    const experienceTypes = [
      { value: "all", label: t("experiences.all") },
      // { value: "private", label: t("experiences.private") },
      // { value: "ticketed", label: t("experiences.ticketed") }
    ]

    const listingStatuses = [
      { value: "published", label: t("experiences.published"), count: publishedCount },
      { value: "draft", label: t("experiences.drafts"), count: draftCount },
      { value: "unpublished", label: t("experiences.deactivated"), count: unpublishedCount }
    ]

    const onListingChange = (tab) => {
      setSelectedListing(tab)
      setPage(1)
    }

    return (
      <>
        <Flex align="center" className={styles.topFilterTabs}>
          {isCompactDevice ? (
            <Select value={activeTab} options={experienceTypes} onChange={onTabChange} className={styles.mobileTypeDropdown} />
          ) : (
            experienceTypes.map(({ value, label }) => (
              <TabPill
                key={value}
                active={activeTab === value}
                onClick={() => onTabChange(value)}
                className={styles.tabButton}
                activeClassName={styles.tabButtonActive}
                inactiveClassName={styles.tabButtonInactive}
              >
                {label}
              </TabPill>
            ))
          )}
          {/* <Space size="medium">
            <Badge count={activeFilterCount} overflowCount={10} size="large" className={styles.filterBadge}>
              <button
                type="button"
                onClick={onFilterIconClick}
                className={`${styles.filterButton} ${isFilterDropdownOpen ? styles.filterButtonActive : ""}`}
                aria-label="Filter options"
                aria-expanded={isFilterDropdownOpen}
                aria-haspopup="true"
              >
                <FilterIcon height={60} width={60} />
              </button>
            </Badge>
            <FilterDropdown
              open={isFilterDropdownOpen}
              onClose={onCloseFilterDropdown}
              onApply={onApplyFilters}
              onClearAll={onClearFilters}
              selectedCategoryIds={selectedCategoryIds}
              selectedDurationTypes={selectedDurationTypes}
            />
          </Space> */}
        </Flex>
        <Flex align="center" wrap gap={3} className={styles.statusFilterTabs}>
          {isCompactDevice ? (
            <Select
              value={activeListingTab}
              options={listingStatuses.map(({ value, label, count }) => ({ value, label: `${label} (${count})` }))}
              onChange={onListingTabChange}
              className={styles.mobileStatusDropdown}
            />
          ) : (
            listingStatuses.map(({ value, label, count }) => (
              <TabPill
                key={value}
                active={activeListingTab === value}
                onClick={() => onListingTabChange(value)}
                className={styles.tab}
                activeClassName={styles.tabActive}
                inactiveClassName={styles.tabInactive}
              >
                {label} <span>{count}</span>
              </TabPill>
            ))
          )}
          {!isCompactDevice && <ViewToggle selectedListing={selectedListing} onChange={onListingChange} />}
        </Flex>
      </>
    )
  }
)

FilterButtons.displayName = "FilterButtons"

FilterButtons.propTypes = {
  selectedListing: PropTypes.string,
  setSelectedListing: PropTypes.func,
  t: PropTypes.func,
  activeTab: PropTypes.string,
  onTabChange: PropTypes.func,
  activeListingTab: PropTypes.string,
  onListingTabChange: PropTypes.func,
  publishedCount: PropTypes.number,
  draftCount: PropTypes.number,
  unpublishedCount: PropTypes.number,
  isFilterDropdownOpen: PropTypes.bool,
  onFilterIconClick: PropTypes.func,
  onCloseFilterDropdown: PropTypes.func,
  FilterDropdown: PropTypes.elementType,
  onApplyFilters: PropTypes.func,
  onClearFilters: PropTypes.func,
  selectedCategoryIds: PropTypes.arrayOf(PropTypes.number),
  selectedDurationTypes: PropTypes.arrayOf(PropTypes.string),
  activeFilterCount: PropTypes.number
}

export default FilterButtons
